import { clamp } from "lodash-es";

import { useGenomeViewerStore } from "../../../store/store.ts";
import { MIN_VISIBLE_AREA_WIDTH, SVG_STYLES } from "../settings.ts";

export function moveCanvasScrollX(offsetX: number, scale: number) {
  const { ctx, getOriginOffset, getMaxWidth, scrollX } = useGenomeViewerStore.getState();

  const newScrollX = clamp(
    getScrollX(offsetX, scale, ctx?.canvas.width ?? 0, getOriginOffset()),
    getOriginOffset(),
    Math.max(getMaxWidth()[0] - (ctx?.canvas.width ?? 0), scrollX),
  );

  useGenomeViewerStore.setState({
    isDraggingRegionIndicator: true,
    scrollX: newScrollX,
  });
}

export function getScrollX(offsetX: number, scale: number, canvasWidth: number, originOffset: number) {
  return (
    (offsetX -
      Math.round(Math.max(canvasWidth * scale, MIN_VISIBLE_AREA_WIDTH) - SVG_STYLES.visibleRegion.strokeWidth / 2) /
        2) /
      scale +
    originOffset
  );
}
